/**
 * The LLM frequently emits its own Sources / Notable Papers / References
 * section at the end of the synthesis (as a bare numbered list, often
 * without URLs). The frontend separately appends a canonical
 * `### 📚 Sources` block built from the verified citations array
 * (`formatSourcesBlock`), which DOES have URLs.
 *
 * Running both produces either a duplicate section or — worse — the
 * unlinked LLM list ahead of the linked canonical one. This helper
 * strips the LLM-emitted Sources-like section so the canonical one
 * stands alone.
 *
 * The match is forgiving:
 *   - Heading levels: `##` or `###`
 *   - Optional leading emoji (`📚 `, `🔖 `, etc.)
 *   - Common alternative titles: Sources, Notable Papers, References,
 *     Bibliography, Citations
 *
 * Removal stops at the next heading of equal or lower depth (so we
 * don't accidentally swallow content after the Sources section).
 * Idempotent: input without a matching section is returned unchanged.
 */
const SECTION_RE = new RegExp(
  String.raw`(^|\n)(#{2,3})\s*(?:[\p{Extended_Pictographic}]\uFE0F?\s*)?` +
    String.raw`(?:Sources|Notable\s+Papers|References|Bibliography|Citations)` +
    String.raw`\s*\n[\s\S]*?(?=\n#{1,3}\s|\n*$)`,
  'iu'
);

export function stripLlmSourcesSection(markdown: string): string {
  if (!markdown) return markdown;
  return markdown.replace(SECTION_RE, '$1').trimEnd();
}
